import { render, staticRenderFns } from "./PendingApprovalDetail.vue?vue&type=template&id=21e70052&scoped=true"
import script from "./PendingApprovalDetail.vue?vue&type=script&lang=js"
export * from "./PendingApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalDetail.vue?vue&type=style&index=0&id=21e70052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e70052",
  null
  
)

export default component.exports